<template>
  <div class="absolute z-30 top-[42px] w-[329px] max-w-[90vw] rounded-[5px] bg-zt-normal
              border border-zt-light shadow-[0px_4px_33px_rgba(0,0,0,0.5)] py-3 px-[15px] left-1/2 -translate-x-1/2
              xl:left-1/3">
    <div v-for="(user, i) in users" :key="user.userId"
         class="flex items-center justify-between gap-1"
         :class="i < users.length - 1 ? 'pb-3 mb-3 border-b border-zt-light/30' : ''">
      <a :href="'/typer/' + user.userId" rel="nofollow"
         class="no-default-style flex items-center gap-2 min-w-0 group">
        <img :src="user.avatar" alt="Avatar"
             class="w-[34px] h-[34px] rounded-full object-cover shrink-0 group-hover:brightness-90 group-active:brightness-75"
             width="34" height="34" @error="handleUserAvatarError($event)" />
        <div class="min-w-0">
          <p class="text-white text-[12px] font-medium leading-[18px] truncate
                    group-hover:brightness-90 group-active:brightness-75 group-hover:underline group-active:underline">
            {{ user.username }}
          </p>
          <div class="flex items-center gap-2 text-white/40 text-[10px] font-semibold font-['Lato'] leading-4">
            <span class="inline-flex items-center gap-1">
              <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_50901_50640)">
                  <path d="M3.57683 0.12461C2.25183 0.524609 1.87683 2.29961 2.92683 3.22461C3.66434 3.87461 4.68933 3.84961 5.40183 3.16211C6.38933 2.21211 5.95184 0.49961 4.61433 0.12461C4.12683 -0.0128907 4.06433 -0.0128907 3.57683 0.12461Z" fill="white" fill-opacity="0.4"/>
                  <path d="M8.3736 0.96214C7.18613 1.57464 7.33613 3.24964 8.62365 3.63714C9.28613 3.83714 9.96113 3.51214 10.2986 2.82464C10.5111 2.37464 10.5236 2.28714 10.3611 1.83714C10.0487 0.949638 9.1611 0.56214 8.3736 0.96214Z" fill="white" fill-opacity="0.4"/>
                  <path d="M1.5875 5.4125C0.924997 5.625 0.3125 6.2625 0.1375 6.9375C0.0625 7.2375 0 8.00003 0 8.61248V9.75H3H6V7.5V5.25L4.0375 5.2625C2.9125 5.2625 1.8625 5.3375 1.5875 5.4125Z" fill="white" fill-opacity="0.4"/>
                  <path d="M7.5 7.5V9.75H9.75H12V8.61248C12 7.125 11.825 6.5 11.275 5.95C10.7125 5.3875 10.2375 5.25 8.72497 5.25H7.5V7.5Z" fill="white" fill-opacity="0.4"/>
                </g>
                <defs>
                  <clipPath id="clip0_50901_50640">
                    <rect width="12" height="9.75" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
              {{ user.followers }}
            </span>
            <span class="w-px h-[13px] bg-[#7A7E86] rounded-[200px]"></span>
            <span class="inline-flex items-center gap-1">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path class="opacity-40" fill-rule="evenodd" clip-rule="evenodd" d="M4.91236 0.0765972C4.8554 0.103496 4.81974 0.160799 4.82127 0.223003C4.84343 1.12596 4.85451 1.64934 4.85451 1.79317V2.19998L4.78541 2.34237C4.7078 2.50227 4.66772 2.5686 4.09926 3.47824C3.87665 3.83446 3.58241 4.32265 3.44542 4.56309C3.28214 4.84967 3.19667 5.17289 3.19728 5.5015L3.20538 9.89149C3.20637 10.4295 3.64947 10.8651 4.19571 10.8651H9.06986L9.24759 10.7792C9.64651 10.5864 9.93948 10.1376 9.94164 9.71585C9.94243 9.55331 9.93722 9.53222 9.85339 9.36205C9.80436 9.2626 9.76687 9.17973 9.77 9.17782C9.77312 9.17599 9.86511 9.13573 9.97436 9.08835C10.4439 8.88459 10.7202 8.56073 10.7402 8.19073C10.7508 7.99539 10.7043 7.8604 10.5475 7.63047C10.4843 7.53778 10.4326 7.4565 10.4326 7.44982C10.4326 7.44318 10.4478 7.43773 10.4666 7.43773C10.4853 7.43773 10.5768 7.39885 10.6699 7.35134C11.0952 7.13432 11.3387 6.7224 11.2696 6.33668C11.2236 6.0797 11.0862 5.87537 10.7808 5.61001L10.6807 5.52307L10.7957 5.40192C10.944 5.24567 11.034 5.11707 11.0931 4.97698C11.132 4.8849 11.1406 4.82594 11.141 4.65024C11.1418 4.3152 11.0632 4.09063 10.877 3.89657C10.7524 3.76657 10.6133 3.68197 10.4168 3.61655L10.2553 3.56282C8.03803 3.55075 6.92941 3.54204 6.92946 3.5367C6.92954 3.52868 6.94824 3.37111 6.97104 3.18651C7.02323 2.76383 7.02892 1.99239 6.9819 1.71181C6.848 0.912844 6.41661 0.287042 5.84899 0.0683184C5.70685 0.0135611 5.66015 0.0058724 5.43839 0.000848258C5.30076 -0.00228424 5.14716 0.00353311 5.09707 0.0137848C5.04696 0.0240162 4.96385 0.05229 4.91236 0.0765972ZM0.301407 4.8084H2.18987C2.35633 4.8084 2.49127 4.94132 2.49127 5.10528V10.9844C2.49127 11.1483 2.35633 11.2812 2.18987 11.2812H0.301407C0.134945 11.2812 0 11.1483 0 10.9844V5.10528C0 4.94132 0.134945 4.8084 0.301407 4.8084Z" fill="white"/>
              </svg>
              {{ user.likes }}
            </span>
          </div>
        </div>
      </a>
      <div class="border border-zt-light rounded-[8px] shrink-0 flex flex-col justify-center
                  py-1.5 px-2 gap-1 w-[100px]"
           style="box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.25);">
        <p class="text-center font-['Poppins'] font-semibold text-xs select-none">
          {{ Math.round((user.stats.ratio * 100).toFixed(1)) + '%' }}
          <span class="font-normal">({{ user.stats.bet_count }})</span>
        </p>
        <div class="flex justify-between items-center gap-1 px-1">
          <div v-for="n in 5" :key="n" class="h-1 rounded-[1px] w-[9px]"
               :style="{ backgroundColor: n <= getBatteryType(user.stats) ? getBatteryColor(user.stats) : getBatteryColor(user.stats) + '26' }"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils_mixin from '../../mixins/utils_mixin.js';

export default {
  name: 'CurrentlyAddingUsersModal',
  mixins: [utils_mixin],
  props: {
    users: {
      type: Array,
      required: true
    }
  },
  methods: {
    getBatteryColor(stats) {
      if (stats.bet_count <= 0) return '#3A4B64';
      if (stats.ratio < 0.2) return '#CE2121';
      if (stats.ratio < 0.4) return '#C55E00';
      if (stats.ratio < 0.65) return '#FAFF00';
      return '#1CC200';
    },
    getBatteryType(stats) {
      if (stats.bet_count <= 0) return 6;
      if (stats.ratio < 0.2) return 1;
      if (stats.ratio < 0.4) return 2;
      if (stats.ratio < 0.65) return 3;
      if (stats.ratio < 0.75) return 4;
      if (stats.ratio < 0.85) return 5;
      return 6;
    }
  }
};
</script>
